<template>
    <el-dialog title="业绩划分统计详情" :visible.sync="isdetailFlag" left width="1400px" custom-class="custom-class-dialog" :before-close="handleClose" :close-on-click-modal="false">
        <div class="hw-content">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="业绩划分结果信息" name="1">
                    <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="ERP订单号">
                            <div class="rows">{{ performanceDetails.Result_ERPOrderSN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单类型">
                            <div class="rows">{{ performanceDetails.Result_OrderID }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="统计日期">
                            {{ elformatDate(performanceDetails.Result_TotalDate, 'yyyy/MM/dd') }}
                        </el-descriptions-item>
                        <el-descriptions-item label="业务日期">
                            {{ elformatDate(performanceDetails.Result_ERPDate, 'yyyy/MM/dd') }}
                        </el-descriptions-item>
                        <el-descriptions-item label="订单办事处">
                            {{ performanceDetails.Result_OrdersOfficeCode || '--' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="订单业务员">{{ performanceDetails.Result_OrdersOfficeManName || '' }}</el-descriptions-item>
                        <el-descriptions-item label="工程名称">{{ performanceDetails.Result_ProjectName || '' }}</el-descriptions-item>
                        <el-descriptions-item label="客户名称">{{ performanceDetails.Result_OrdersCustomerName || '' }}</el-descriptions-item>
                        <el-descriptions-item label="对冲状态">{{ performanceDetails.Result_ValidStatus == 0 ? '正常' : '对冲' }}</el-descriptions-item>
                        <el-descriptions-item label="数据类型">{{ performanceDetails.Result_DataType == 0 ? '原始数据' : '业绩划分数据' }}</el-descriptions-item>
                        <el-descriptions-item label="版本号">{{ performanceDetails.Result_Version || '' }}</el-descriptions-item>
                        <el-descriptions-item label="修改时间">{{ elformatDate(performanceDetails.Result_UpdateDate, 'yyyy-MM-dd hh:mm:ss')  }}</el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
                <el-collapse-item title="业绩分配明细" name="2">
                    <el-table :data="DistributeDetail" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="Result_OfficeCode" label="办事处编号" align="center"></el-table-column>
                        <el-table-column prop="Result_OfficeMemberCode" label="业务员编号" align="center"></el-table-column>
                        <el-table-column prop="Result_Rate" label="比例（%）" align="center"></el-table-column>
                        <el-table-column prop="Result_OfficeMemberName" label="业务员姓名" align="center"></el-table-column>
                        <el-table-column prop="Result_DeliveryAmount" label="发货金额" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Result_ReceivedAmount" label="回款金额" align="center"></el-table-column>
                        <el-table-column prop="Result_TotalDate" label="统计日期" align="center">
                            <template v-slot="scope">
                                {{ scope.row.Result_TotalDate | formatDate }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Result_ValidStatus" label="对冲状态" align="center">
                            <template v-slot="scope">
                                {{ scope.row.Result_ValidStatus != 1 ? '正常' : '对冲' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Result_DataType" label="数据类型" align="center">
                            <template v-slot="scope">
                                {{ scope.row.Result_DataType == 0 ? '原始数据' : '业绩划分数据' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Result_Version" label="版本号" align="center"></el-table-column>
                        <el-table-column prop="Result_ERPDate" label="业务日期" align="center">
                            <template v-slot="scope">
                                {{ scope.row.Result_ERPDate | formatDate }}
                            </template>
                        </el-table-column>
                        <el-table-column width="150" prop="Result_UpdateDate" label="修改日期" align="center">
                            <template v-slot="scope">
                                {{ elformatDate(scope.row.Result_UpdateDate, 'yyyy-MM-dd hh:mm:ss') }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-collapse-item>
                <el-collapse-item title="发货、退货明细" name="3">
                    <el-table :data="sendList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="日期" label="日期" align="center" width="80"></el-table-column>
                        <el-table-column prop="发货类型" label="发货类型" align="center" width="120"></el-table-column>
                        <el-table-column prop="ERP订单号" label="ERP订单号" align="center" width="120"></el-table-column>
                        <el-table-column prop="行号" label="行号" align="center" width="120"></el-table-column>
                        <el-table-column prop="下达号" label="下达号" align="center" width="120"></el-table-column>
                        <el-table-column prop="办事处编号" label="办事处编号" align="center" width="120"></el-table-column>
                        <el-table-column prop="业务员编号" label="业务员编号" align="center" width="120"></el-table-column>
                        <el-table-column prop="业务员名称" label="业务员名称" align="center" width="120"></el-table-column>
                        <el-table-column prop="数量" label="数量" align="center" width="120"></el-table-column>
                        <el-table-column prop="单价" label="单价" align="center" width="120"></el-table-column>
                        <el-table-column prop="客户编号" label="客户编号" align="center" width="120"></el-table-column>
                        <el-table-column prop="客户名称" label="客户名称" align="center" width="120"></el-table-column>
                    </el-table>
                </el-collapse-item>

                <el-collapse-item title="回款明细" name="4">
                    <el-table :data="backMoney" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                        <el-table-column prop="日期" label="日期" align="center" width="120"></el-table-column>
                        <el-table-column prop="ERP订单号" label="ERP订单号" align="center" width="120"></el-table-column>
                        <el-table-column prop="订单类型" label="订单类型" align="center" width="120"></el-table-column>
                        <el-table-column prop="办事处编号" label="办事处编号" align="center" width="120"></el-table-column>
                        <el-table-column prop="业务员编号" label="业务员编号" align="center" width="120"></el-table-column>
                        <el-table-column prop="业务员名称" label="业务员名称" align="center"></el-table-column>
                        <el-table-column prop="回款金额" label="回款金额" align="center" width="120"></el-table-column>
                        <el-table-column prop="客户编号" label="客户编号" align="center" width="120"></el-table-column>
                        <el-table-column prop="客户名称" label="客户名称" align="center"></el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
            <el-button @click="handleClose">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        isdetailFlag: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            activeNames: ['1', '2', '3', '4'],
            performanceDetails: {},
            DistributeDetail: [], //业绩划分规则明细
            sendList: [], //发货退货明细
            backMoney: [] //回款明细
        };
    },
    watch: {
        isdetailFlag(newval, oldval) {
            if (newval) {
                this.getOrdersPerformanceResultByID(this.id);
            }
        }
    },
    mounted() {},
    methods: {
        // 获取业绩统计详情
        async getOrdersPerformanceResultByID(e) {
            this.performanceDetails = {};
            this.DistributeDetail = [];
            this.sendList = [];
            this.backMoney = [];
            var result = await this.$newsApi.getOrdersPerformanceResultByID({
                ID: e,
                ifBack: true
            });
            if (result.data.data) {
                this.performanceDetails = result.data.data;
                this.getPerformanceResultDetail(this.id);
                this.getCreateTableGSTDeliveryMoney();
                this.getCreateTableGSTBackMoney();
            }
        },
        // 获取业绩划分详情-业绩分配明细
        async getPerformanceResultDetail(e) {
            var result = await this.$newsApi.getPerformanceResultDetail({
                ID: e
            });
            this.DistributeDetail = result.data.data;
        },
        // 获取业绩划分详情-发货退货明细
        async getCreateTableGSTDeliveryMoney(e) {
            var result = await this.$newsApi.getCreateTableGSTDeliveryMoney({
                OrderSN: this.performanceDetails.Result_ERPOrderSN,
                Date: this.performanceDetails.Result_TotalDate.split('T')[0]
            });
            if (result.data.data) {
                this.sendList = result.data.data;
            } else {
                this.sendList = [];
            }
        },
        // 获取业绩划分详情-回款明细
        async getCreateTableGSTBackMoney(e) {
            var result = await this.$newsApi.getCreateTableGSTBackMoney({
                OrderSN: this.performanceDetails.Result_ERPOrderSN,
                Date: this.performanceDetails.Result_TotalDate.split('T')[0]
            });
            if (result.data.data) {
                this.backMoney = result.data.data;
            } else {
                this.backMoney = [];
            }
        },
        /*
      关闭详情
      */
        handleClose() {
            this.$emit('handleClose');
        },
        /*
      打开文件
      */
        downFile(par, flag) {
            if (flag) {
                window.open(par);
                return;
            }
            this.$newsApi.common.getUrlPath().then((res) => {
                if (res.data.Resultcode == 0) {
                    let path = res.data.data;
                    let paths = path + par;
                    window.open(paths);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-class-dialog {
}
.hw-content {
    padding: 0 20px;
}


/* 通用样式 */
.rows {
    width: 389px;
}
</style>
